import { BrowserRouter, Route, Routes } from 'react-router-dom'

import Login from './pages/Login'
import Login2FA from './pages/Login2FA'
import RequestPasswordReset from './pages/RequestPasswordReset'
import ResetPassword from './pages/ResetPassword'
import Wrapper from './components/Wrapper'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import { useEffect } from 'react'
import { useData } from './data/Data'

function App() {
  const { name } = useData()

  useEffect(() => {
      updateFavicon()
      updateTitle(name)
  }, [name])

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login appName={name} />} />
          <Route path="/login2fa" element={<Login2FA appName={name} />} />
          <Route path="/request-password-reset" element={<RequestPasswordReset appName={name} />} />
          <Route path="/reset-password" element={<ResetPassword appName={name} />} />
          <Route path='*' element={<Wrapper appName={name} />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer position='bottom-right' />
    </>
  )
}

const updateFavicon = () => {
  let faviconUrl = `${process.env.REACT_APP_API_URL}/images/logo_small_white.png`
  let link = document.querySelector("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = faviconUrl

  let appleIcon = document.querySelector("link[rel='apple-touch-icon']")
  if (!appleIcon) {
    appleIcon = document.createElement('link')
    appleIcon.rel = 'apple-touch-icon'
    document.head.appendChild(appleIcon)
  }
  appleIcon.href = faviconUrl
}

const updateTitle = (appName) => {
  document.title = appName
}

export default App